import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", "px;\n  transform: none;\n  transform-origin: top;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  transform: rotate(", ");\n  transition: transform ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: inherit;\n  margin-left: 1em;\n  margin-right: 0.28em;\n  opacity: 0.7;\n  width: 1px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding-right: 0.28em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useState } from 'react';
import styled from 'styled-components';
import { withoutProps, withOutsideClick } from '@scp/ui-shared/core/hoc';
import { Icon } from '@scp/ui-shared/theme/icons';
import { property, color } from '@scp/ui-shared/theme/variables';
import { Button } from './Button'; // eslint-disable-next-line import/no-relative-parent-imports

import { Popover } from '../popover/Popover';
var StyledButton = styled(Button)(_templateObject());
var Separator = styled.span.attrs({
  'aria-hidden': true
})(_templateObject2(), color.background);
var ArrowIcon = styled(withoutProps(Icon, ['isOpen'])).attrs({
  color: color.palette.white,
  size: 18
})(_templateObject3(), function (props) {
  return props.isOpen ? '-180deg' : '0';
}, property.transition);
var Wrapper = styled(withOutsideClick('div'))(_templateObject4());
var StyledPopover = styled(Popover)(_templateObject5(), property.borderRadius);
/**
 * Button with Dropdown content component.
 * It extends `<Button />` and `<Popover />` components.
 * You can use all props of `<Button />`.
 *
 * @example ./__docs__/DropdownButton.md
 */

export function DropdownButton(_a) {
  var _a$defaultExpanded = _a.defaultExpanded,
      defaultExpanded = _a$defaultExpanded === void 0 ? false : _a$defaultExpanded,
      label = _a.label,
      children = _a.children,
      _a$triangleOffset = _a.triangleOffset,
      triangleOffset = _a$triangleOffset === void 0 ? 16 : _a$triangleOffset,
      _a$popupWidth = _a.popupWidth,
      popupWidth = _a$popupWidth === void 0 ? 220 : _a$popupWidth,
      buttonProps = __rest(_a, ["defaultExpanded", "label", "children", "triangleOffset", "popupWidth"]);

  var _useState = useState(defaultExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var toggle = function toggle() {
    return setIsExpanded(!isExpanded);
  };

  var collapse = function collapse() {
    return setIsExpanded(false);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !isExpanded) {
      e.preventDefault();
      setIsExpanded(true);
    }
  };

  var handleMouseDown = function handleMouseDown(e) {
    return e.preventDefault();
  }; // See `<Popover />` for more details


  return React.createElement(Wrapper, {
    onClickOutside: collapse,
    onKeyDown: handleKeyDown
  }, React.createElement(StyledButton, Object.assign({
    onClick: toggle,
    "aria-expanded": isExpanded,
    onMouseDown: handleMouseDown
  }, buttonProps, {
    "aria-haspopup": true
  }), label, React.createElement(Separator, null), React.createElement(ArrowIcon, {
    name: "keyboard-arrow-down",
    isOpen: isExpanded
  })), React.createElement(StyledPopover, {
    open: isExpanded,
    triangleOffset: triangleOffset,
    offset: "7px 0 0 -6px",
    width: popupWidth,
    onClose: collapse
  }, children));
}